import React from 'react';
import { FC } from 'react';
import { IconProps } from '../types';

export const OtherDocumentsIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 18 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M10.75 0.75V4.75C10.75 5.28043 10.9607 5.78914 11.3358 6.16421C11.7109 6.53929 12.2196 6.75 12.75 6.75H16.75M4.75 11.75H6.75M10.75 11.75H12.75M4.75 15.75H6.75M10.75 15.75H12.75M11.75 0.75H2.75C2.21957 0.75 1.71086 0.960714 1.33579 1.33579C0.960714 1.71086 0.75 2.21957 0.75 2.75V18.75C0.75 19.2804 0.960714 19.7891 1.33579 20.1642C1.71086 20.5393 2.21957 20.75 2.75 20.75H14.75C15.2804 20.75 15.7891 20.5393 16.1642 20.1642C16.5393 19.7891 16.75 19.2804 16.75 18.75V5.75L11.75 0.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
